import { Link } from 'react-router-dom'
import { useCollection } from '../../hooks/useFirestore'
import './AdminEditor.css'

export default function CipherList() {
  const { data: ciphers, loading } = useCollection('ciphers', { orderByField: 'sortOrder' })

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className="container">
      <div className="editor-header">
        <h1>Ciphers</h1>
        <Link to="/admin/ciphers/new" className="btn btn-primary">
          + New Cipher
        </Link>
      </div>

      {ciphers.length === 0 ? (
        <div className="empty-state">
          <p>No ciphers yet.</p>
          <p className="text-secondary">Create your first cipher or import existing cipher definitions.</p>
        </div>
      ) : (
        <div className="admin-list">
          {ciphers.map(cipher => {
            const subCount = Object.keys(cipher.substitutions || {}).length
            const hasCharCipher = !!(cipher.characterCipher || cipher.character_cipher)
            return (
              <Link
                key={cipher.id}
                to={`/admin/ciphers/${cipher.id}`}
                className="admin-list-item"
              >
                <div className="item-image lore-placeholder">
                  <span>{hasCharCipher ? '🔐' : '📝'}</span>
                </div>
                <div className="item-info">
                  <h3>{cipher.name}</h3>
                  <p className="text-secondary">
                    {cipher.description || 'No description'}
                  </p>
                </div>
                <div className="item-meta">
                  <span className="item-badge badge-pc">
                    {subCount} substitution{subCount !== 1 ? 's' : ''}
                  </span>
                  {hasCharCipher && (
                    <span className="item-badge badge-npc">
                      + char cipher
                    </span>
                  )}
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
